/**
 * @desc OMS取消售后退货单
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/cancelSaleIn`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
